import React, { FunctionComponent } from 'react';
import Illustration from './illustration.svg';

export type HeroTitleProps = {
    text: string;
};

const HeroTitle: FunctionComponent<HeroTitleProps> = ({ text }) => {
    // @ts-ignore
    const illustrationElement = <Illustration className="hero-title__image" />;
    return (
        <div className="hero-title">
            {illustrationElement}
            <h1 className="hero-title__text">{text}</h1>
        </div>
    );
};

export default HeroTitle;
